<template>
    <div class="row step">
        <div class="col-4  position-relative">
            <div class="time d-flex align-items-center justify-content-md-end ">
                <div class="hour d-none d-lg-block" v-if="time">
                    <div class="white-pill bg-white my-1 rounded-10 border border-dark px-2 ml-2 d-flex align-items-center">
                        <svg-icon name="clock" width="15" color="black"/>
                        <span class="align-self-center ml-1">{{ time }}</span>
                    </div>
                </div>
                <div v-if="title === 'Return Home'" class="circle-icon ml-2 cursor-pointer bg-white">
                    <svg-icon name="house" width="15" color="black"/>
                </div>
                <div v-if="title === 'Attend Appointment'" class="circle-icon ml-2 cursor-pointer bg-white ">
                    <svg-icon aria-labelledby=" calendar icon " name="calendar" width="15" color="black"/>
                </div>
                <div v-if="title === 'Arrive at the destination'" class="circle-icon ml-2 cursor-pointer bg-white ">
                    <svg-icon  name="location" width="15" color="black"/>
                </div>
            </div>
            <div v-if=" title === 'Return Home' " class="vertical-line position-absolute" style="visibility:hidden"></div>
        </div>
        <div class="col-8 pl-0">
            <div class="details">
                <div class="hour col-4 pl-0 d-lg-none">
                    <div v-if="title !== 'Arrive at the destination'" class="white-pill bg-white my-1 rounded-10 border border-dark px-2 ml-2 d-flex align-items-center">
                        <svg-icon name="clock" width="15" color="black"/>
                        <span class="align-self-center ml-1">{{time}}</span>
                    </div>
                </div>
                <div v-if="title !== 'Return Home'" class="card mt-2 custom-stage-background"  >
                    <div class="card-body">
                        <h2 class="text-white">{{ title }}</h2>
                        <h2 class="text-white mt-3 fw-normal" v-if="text">{{ text }}</h2>
                    </div>
                </div>
                <div v-if="title === 'Return Home'" class="card mt-2 custom-stage-background" >
                    <div class="card-body">
                        <h2 class="text-white">{{ title }}</h2>
                        <h2 class="text-white mt-3 fw-normal" v-if="text">{{ text }}</h2>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'custom-stage-item',
    props: ['time', 'title', 'text', 'journey'],
}

</script>
